import { gql } from '@apollo/client';

export const FETCH_STREAM_CHANNEL = gql`
  query FetchStreamChannel($streamioId: String!) {
    streamChannel(streamioId: $streamioId) {
      id
    }
  }
`;
